// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e5f33c4b","581":"8cf50646","705":"4dda0ce0"}[chunkId] + ".chunk.js";
};